import { Style } from 'mapbox-gl';

import { State } from './reducer';

const { NODE_ENV = 'development' } = process.env;

const mapStyleBase = require(NODE_ENV === 'production'
  ? '../models/mapStyleProd.json'
  : '../models/mapStyle.json');

const basemapStyles = [require('../models/mapStyleStreets.json'), mapStyleBase];

const initialState: State = {
  agreements: {},
  agreementsPopupTab: 0,
  agreementsTable: { order: 'asc', orderBy: 'name' },
  basemapStyles: basemapStyles as Style[],
  companyOptions: [],
  documentsRequested: [],
  identify: { entities: {}, location: null, selectedId: null },
  isAgreementsTableOpen: false,
  isPopupLoading: false,
  laserficheCredentials: {
    username: '',
    password: '',
    initials: '',
    isVerified: false
  },
  map: { center: [-94.93, 29.36], zoom: 11.5 },
  mapLayerBounds: {},
  mapPopupLayers: [
    'docks',
    'hbt-secretary-files',
    'hbt-properties',
    'tctrr-properties',
    'gcad-parcels',
    'properties-line',
    'properties-point',
    'properties-poly',
    'temp-hbt-files-points',
    'temp-hbt-files-lines',
    'temp-hbt-files-polygon',
    'temp-ordinance-points',
    'temp-ordinance-lines',
    'temp-ordinance-polygon',
    'levee-gates',
    'tctrr-projects-polygon',
    'tctrr-projects-line',
    'pipelines',
    'product-pipelines',
    'tctrr-acquisitions-closed',
    'tctrr-acquisitions-pending',
    'tctrr-acquisitions-target'
  ],
  mapStyleBase: mapStyleBase as Style,
  title: '',
  sidebarTab: 0,
  signInDialog: {
    open: false,
    errorMessage: '',
    isLoading: false
  },
  searchFields: [],
  selectedAgreementId: null,
  selectedTableAgreementMapLocation: { bounds: null, popupAnchor: null },
  todoActions: ['fetchAgreements'],
  toggleableLayers: [
    {
      key: 'acquisitions-closed',
      title: 'Acquisitions (Closed)',
      isChecked: true,
      controlledLayerIds: ['tctrr-acquisitions-closed', 'tctrr-acquisitions-closed-border']
    },
    {
      key: 'acquisitions-pending',
      title: 'Acquisitions (Pending)',
      isChecked: true,
      controlledLayerIds: ['tctrr-acquisitions-pending', 'tctrr-acquisitions-pending-border']
    },
    {
      key: 'acquisitions-target',
      title: 'Acquisitions (Target)',
      isChecked: true,
      controlledLayerIds: ['tctrr-acquisitions-target', 'tctrr-acquisitions-target-border']
    },
    {
      key: 'agreements',
      title: 'Agreements',
      isChecked: true,
      controlledLayerIds: [
        'properties-poly',
        'properties-poly-border',
        'properties-poly-label',
        'properties-line',
        'properties-line-label',
        'properties-point',
        'properties-point-label'
      ]
    },
    {
      key: 'docks',
      title: 'Docks',
      isChecked: true,
      controlledLayerIds: ['docks']
    },
    {
      key: 'hbt-secretary-files',
      title: 'HBT Secretary Files ',
      isChecked: true,
      controlledLayerIds: ['hbt-secretary-files', 'hbt-secretary-files-border']
    },
    {
      key: 'hbt-properties',
      title: 'HBT Properties',
      isChecked: true,
      controlledLayerIds: ['hbt-properties', 'hbt-properties-border']
    },
    {
      key: 'hbt-files',
      title: 'HBT Files',
      isChecked: true,
      controlledLayerIds: [
        'temp-hbt-files-points',
        'temp-hbt-files-lines',
        'temp-hbt-files-polygon',
        'temp-hbt-files-polygon-border'
      ]
    },
    {
      key: 'ordinance',
      title: 'Ordinance',
      isChecked: true,
      controlledLayerIds: [
        'temp-ordinance-polygon',
        'temp-ordinance-polygon-border',
        'temp-ordinance-lines',
        'temp-ordinance-points'
      ]
    },
    {
      key: 'bnsf-properties',
      title: 'BNSF Properties',
      isChecked: true,
      controlledLayerIds: ['bnsf-properties', 'bnsf-properties-border']
    },
    {
      key: 'union-pacfic-properties',
      title: 'Union Pacific Properties',
      isChecked: true,
      controlledLayerIds: ['union-pacific-properties', 'union-pacific-properties-border']
    },
    {
      key: 'tctrr-properties',
      title: 'TCTRR Properties',
      isChecked: true,
      controlledLayerIds: ['tctrr-properties', 'tctrr-properties-border']
    },
    {
      key: 'gcad-parcels',
      title: 'GCAD Parcels (Zoom In to View)',
      isChecked: true,
      controlledLayerIds: ['gcad-parcels', 'gcad-parcels-border']
    },
    {
      key: 'levee-gates',
      title: 'Hurricane Levee Gates',
      isChecked: true,
      controlledLayerIds: ['levee-gates', 'levee-gates-label']
    },
    {
      key: 'tctrr-projects',
      title: 'TCTRR Projects',
      isChecked: false,
      controlledLayerIds: [
        'tctrr-projects-polygon',
        'tctrr-projects-line',
        'tctrr-projects-poly-label',
        'tctrr-projects-line-label'
      ]
    },
    {
      key: 'product-pipelines',
      title: 'Product Pipelines',
      isChecked: false,
      controlledLayerIds: ['product-pipelines']
    },
    {
      key: 'crude-pipelines',
      title: 'Crude Pipelines',
      isChecked: false,
      controlledLayerIds: ['pipelines']
    }
  ]
};

export default initialState;
